module.exports = __webpack_public_path__ + "static/media/34.933d3933.mp3";